import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainPoint } from './components/PainPoint';
import { ProtocolIntro } from './components/ProtocolIntro';
import { Benefits } from './components/Benefits';
import { ForYou } from './components/ForYou';
import { HowItWorks } from './components/HowItWorks';
import { Results } from './components/Results';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <PainPoint data-id="element-3" />
        <ProtocolIntro data-id="element-4" />
        <Benefits data-id="element-5" />
        <ForYou data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Results data-id="element-8" />
        <FAQ data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}